interface ISbImgServiceOptions {
  height?: number
  width?: number
  quality?: number
  fileType?: string
  focusPoint?: string
}

export function getStoryblokImageURL(src: string, options?: ISbImgServiceOptions) {
  const nuxtImage = useImage()

  return nuxtImage(
    src,
    {
      height: options?.height,
      width: options?.width,
      quality: options?.quality ?? 80,
      filters: {
        fileType: 'webp',
        focusPoint: options?.focusPoint
      }
    },
    { provider: 'storyblok' }
  )
}
